import React from 'react';
import './error.css';
import errorImg from '../../assets/error.jpg';
import { NavLink } from 'react-router-dom';

function Error() {
  return (
    <div className='error-container'>
      <div className="error-div">
        <div className="error-left">
          4O4 Page not found.
        </div>
        <div className="error-right">
          <img src={errorImg} alt="" />
          <p>Moye moye!!!</p>
        </div>
      </div>
      <NavLink to="/">Go back to Home</NavLink>
    </div>
  )
}

export default Error